/**
 * Created by ferasmasood on 8/16/17.
 */
window.GlobalSearchDataManager = new (function () {
    var self = this;

    self.lastPhraseOffset;
    self.hUser;
    self.getSearchResult = function (hUser, searchPhrase, offset, limit, types) {
        self.hUser = hUser;
        if (!offset) {
            offset = 0;
        }

        if (!limit) {
            limit = GlobalSearchAPI.RECORDS_LIMIT;
        }

        self.searchPhrase = searchPhrase;
        var date = new Date();
        var timeStamp = date.getTime();
        self.lastPhraseOffset = searchPhrase + "_" + offset;
        var deferred = $q.defer();
        if (!searchPhrase || searchPhrase.length == 0) {
            deferred.reject ("Empty search String");
        }
        GlobalSearchAPI.getGlobalSearchResult(timeStamp, self.hUser.getUserContext().brand_id, searchPhrase, offset, limit, types).then(function (res) {
            if (res.searchPhrase + "_" + res.offset == self.lastPhraseOffset) {
                res.results = formatResult(res.results)
                deferred.resolve(res);
            }

        }, function (err) {
            deferred.reject(err);
        })
        return deferred.promise;
    }


    var capitalizeString = function (string) {
        var stringWords = string.split(" ");
        for (var wordIndex in stringWords) {
            if (stringWords[wordIndex].length > 0) {
                if (stringWords[wordIndex].indexOf('<b>') !== 0) {
                    stringWords[wordIndex] = stringWords[wordIndex][0].toUpperCase() + stringWords[wordIndex].substr(1, stringWords[wordIndex].length - 1)
                } else {
                    stringWords[wordIndex] = stringWords[wordIndex].substr(0, 3) + stringWords[wordIndex][3].toUpperCase() + stringWords[wordIndex].substr(4, stringWords[wordIndex].length - 1)
                }
            }
        }
        return stringWords.join(" ")
    }

    var formatResult = function (result) {
        var dateFormat = "MMMM Do YYYY";
        var primaryLocation = null;
        _.map(result, function (entry) {
            entry.id = entry.type + entry.details.id;
            switch (entry.type) {
                case GlobalSearchAPI.RESULT_TYPE_APPLICANT:
                    entry.formattedName = entry.details.applicant.name.toLowerCase();
                    if (entry.details.job.alias_position) {
                        entry.formattedPosition = entry.details.job.alias_position.toLowerCase();
                    }
                    else {
                        entry.formattedPosition = entry.details.job.position.name.toLowerCase();
                    }
                    entry.formattedLocation = entry.details.brand.name.toLowerCase();

                    var searchWords = self.searchPhrase.split(" ");
                    for (var searchWordIndex in searchWords) {
                        var word = searchWords[searchWordIndex].toLowerCase();
                        entry.formattedName = entry.formattedName.replace(word, "<b>" + word + "</b>");
                        entry.formattedPosition = entry.formattedPosition.replace(word, "<b>" + word + "</b>");
                        entry.formattedLocation = entry.formattedLocation.replace(word, "<b>" + word + "</b>");

                    }

                    entry.formattedName = capitalizeString(entry.formattedName);
                    entry.formattedPosition = capitalizeString(entry.formattedPosition);
                    entry.formattedLocation = capitalizeString(entry.formattedLocation);
                    entry.formattedExtra = $filter("translate")("Applied to") + " " + "<b>" + entry.formattedPosition + "</b>";
                    entry.formattedType = $filter("translate")("View application");

                    var nameWords = entry.details.applicant.name.split(" ");
                    if (nameWords && nameWords.length) {
                        entry.first_name = nameWords[0];
                        entry.first_name = nameWords[nameWords.length - 1];
                    }
                    entry.typeClass = "applicant";
                    entry.url = "appLayout.harriSH.AMS.applicants({job_id:" + entry.details.job.id + ", app_id: " + entry.details.id + ",bucket_id:'DIRECT'})";
                    entry.stateName = "appLayout.harriSH.AMS.applicants";
                    entry.stateParams = {
                        job_id:entry.details.job.id,
                        app_id: entry.details.id,
                        bucket_id:'DIRECT'
                    };
                    break;

                case GlobalSearchAPI.RESULT_TEAM_LIVE_EMPLOYEE:
                    entry.formattedName = entry.details.user.name.toLowerCase();
                    entry.details.brands = entry.details.brands.sort(function (brand1, brand2) {
                        return Number(brand2.is_primary_location) - Number(brand1.is_primary_location);
                    });
                    for (var i in entry.details.brands) {
                        var brand = entry.details.brands[i];
                        if (brand.is_primary_location && brand.is_scheduling_member) {
                            primaryLocation = brand;
                        }

                        entry.primaryLocation = primaryLocation;

                        if (primaryLocation && (brand.id !== primaryLocation.id)) {
                            entry.otherBrands = entry.otherBrands || [];
                            var brandFounded = entry.otherBrands.find(function (tempBrand) {
                                return brand.id === tempBrand.id;
                            });

                            if (!brandFounded ){
                                entry.otherBrands.push(brand);
                                entry.otherBrandsTooltip = entry.otherBrandsTooltip || $filter('translate')('Other Locations') + ":";
                                entry.otherBrandsTooltip += brand.name +  (i == (entry.details.brands.length -1) ? '' : ", ");
                            }
                        }
                    }

                    if (primaryLocation) {
                        entry.formattedLocation = primaryLocation.name.toLowerCase();

                        var searchWords = self.searchPhrase.split(" ");
                        for (var searchWordIndex in searchWords) {
                            var word = searchWords[searchWordIndex].toLowerCase();
                            entry.formattedName = entry.formattedName.replace(word, "<b>" + word + "</b>");
                            entry.formattedLocation = entry.formattedLocation.replace(word, "<b>" + word + "</b>");

                        }

                        entry.formattedName = capitalizeString(entry.formattedName);
                        entry.formattedLocation = capitalizeString(entry.formattedLocation);
                        entry.formattedExtra = primaryLocation.name + " Core HR " + $filter("translate")("profile");
                        entry.formattedType = $filter("translate")("CoreHR profile");

                        var nameWords = entry.details.user.name.split(" ");
                        if (nameWords && nameWords.length) {
                            entry.first_name = nameWords[0];
                            entry.first_name = nameWords[nameWords.length - 1]
                        }
                        entry.typeClass = "team-live";
                        entry.url = "appLayout.harriSH.core-hr.profile({brand_id:" + entry.details.financial_unit_brand_id + ", user_id: " + entry.details.user.user_id + "})";
                        entry.stateName = "appLayout.harriSH.core-hr.profile";
                        entry.stateParams = {
                            brand_id: entry.details.financial_unit_brand_id,
                            brandId: entry.details.financial_unit_brand_id,
                            user_id: entry.details.user.user_id
                        };
                    }
                    break;

                case GlobalSearchAPI.RESULT_ONBOARDING_EMPLOYEE:
                    entry.formattedName = entry.details.user.name.toLowerCase();
                    entry.formattedLocation = entry.details.brand.name.toLowerCase();

                    var searchWords = self.searchPhrase.split(" ");
                    for (var searchWordIndex in searchWords) {
                        var word = searchWords[searchWordIndex].toLowerCase();
                        entry.formattedName = entry.formattedName.replace(word, "<b>" + word + "</b>");
                        entry.formattedLocation = entry.formattedLocation.replace(word, "<b>" + word + "</b>");

                    }

                    entry.formattedName = capitalizeString(entry.formattedName);
                    entry.formattedLocation = capitalizeString(entry.formattedLocation);
                    entry.formattedExtra = entry.details.brand.name + " " + $filter("translate")("Onboarding Documents");
                    entry.formattedType = $filter("translate")("Employee docs");

                    var nameWords = entry.details.user.name.split(" ")
                    if (nameWords && nameWords.length) {
                        entry.first_name = nameWords[0]
                        entry.first_name = nameWords[nameWords.length - 1]
                    }
                    entry.typeClass = "onboarding-employee";
                    entry.url = "appLayout.harriSH.docs({user_id: " + entry.details.user.id + ", brand_id: " + entry.details.brand.id + "})";
                    entry.stateName = "appLayout.harriSH.docs";
                    entry.stateParams = {
                        brand_id: entry.details.brand.id,
                        user_id: entry.details.user.id
                    };
                    break;
            }
            return entry;
        })
        return result;
    }

});


